/* BlunderClub shortlist: localStorage wishlist + recently viewed.
   Items: {h: handle, t: title, u: url, i: image src, p: price, c: compare-at (optional)} */
(function () {
  if (window.CCShortlist) return;

  var KEYS = { saved: 'cc_saved', recent: 'cc_recent' };

  function read(key) {
    try {
      return JSON.parse(localStorage.getItem(key)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(key, items) {
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch (e) {
      /* private mode / quota: feature degrades silently */
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  var CC = (window.CCShortlist = {
    isSaved: function (handle) {
      return read(KEYS.saved).some(function (x) {
        return x.h === handle;
      });
    },
    toggle: function (item) {
      var saved = read(KEYS.saved);
      var idx = saved.findIndex(function (x) {
        return x.h === item.h;
      });
      if (idx > -1) saved.splice(idx, 1);
      else saved.unshift(item);
      write(KEYS.saved, saved.slice(0, 60));
      render();
      syncButtons();
      return idx === -1;
    },
    recordRecent: function (item) {
      var recent = read(KEYS.recent).filter(function (x) {
        return x.h !== item.h;
      });
      recent.unshift(item);
      write(KEYS.recent, recent.slice(0, 12));
    },
  });

  function cardHtml(item, removable) {
    var img = item.i ? String(item.i).replace(/([?&]width=)\d+/, '$1600') : '';
    var mid = (removable ? 'sv-' : 'rc-') + item.h;
    var quickAdd =
      '<div class="quick-add no-js-hidden">' +
      '<modal-opener data-modal="#QuickAdd-' + esc(mid) + '">' +
      '<button type="button" class="quick-add__submit button button--full-width button--primary" aria-haspopup="dialog" data-product-url="' + esc(item.u) + '">' +
      'Choose options' +
      '<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>' +
      '</button></modal-opener>' +
      '<quick-add-modal id="QuickAdd-' + esc(mid) + '" class="quick-add-modal">' +
      '<div role="dialog" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">' +
      '<button id="ModalClose-' + esc(mid) + '" type="button" class="quick-add-modal__toggle" aria-label="Close">&times;</button>' +
      '<div id="QuickAddInfo-' + esc(mid) + '" class="quick-add-modal__content-info"></div>' +
      '</div></quick-add-modal></div>';
    var price =
      '<span class="cc-sl-price' + (item.c ? ' cc-sl-price--sale' : '') + '">' +
      esc(item.p) +
      (item.c ? ' <s>' + esc(item.c) + '</s>' : '') +
      '</span>';
    return (
      '<div class="cc-sl-card">' +
      (removable
        ? '<button type="button" class="cc-sl-remove" data-cc-remove="' +
          esc(item.h) +
          '" aria-label="Remove ' +
          esc(item.t) +
          ' from shortlist">&times;</button>'
        : '') +
      '<a href="' + esc(item.u) + '" class="cc-sl-link">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(item.t) + '" loading="lazy" width="600" height="750">' : '') +
      '<span class="cc-sl-title h5">' + esc(item.t) + '</span>' +
      price +
      '</a>' +
      quickAdd +
      '</div>'
    );
  }

  function render() {
    document.querySelectorAll('[data-cc-row]').forEach(function (row) {
      var kind = row.getAttribute('data-cc-row');
      var items = read(KEYS[kind] || '');
      var exclude = row.getAttribute('data-cc-exclude');
      if (exclude) {
        items = items.filter(function (x) {
          return x.h !== exclude;
        });
      }
      var wrap = row.closest('[data-cc-wrap]');
      if (!items.length) {
        if (wrap) wrap.hidden = true;
        row.innerHTML = '';
        return;
      }
      if (wrap) wrap.hidden = false;
      row.innerHTML = items
        .map(function (item) {
          return cardHtml(item, kind === 'saved');
        })
        .join('');
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-cc-save]').forEach(function (btn) {
      var on = CC.isSaved(btn.getAttribute('data-cc-save'));
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('.cc-save-label');
      if (label) {
        label.textContent = on
          ? btn.getAttribute('data-label-saved') || 'Saved'
          : btn.getAttribute('data-label-save') || 'Save for later';
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-save]');
    if (btn) {
      try {
        CC.toggle(JSON.parse(btn.getAttribute('data-cc-item')));
      } catch (err) {
        /* malformed item: ignore */
      }
      return;
    }
    var remove = e.target.closest('[data-cc-remove]');
    if (remove) {
      CC.toggle({ h: remove.getAttribute('data-cc-remove') });
    }
  });

  function init() {
    var current = document.querySelector('[data-cc-current-product]');
    if (current) {
      try {
        CC.recordRecent(JSON.parse(current.textContent));
      } catch (err) {
        /* ignore */
      }
    }
    render();
    syncButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
